<template>
	<PageContainer
		:class="$isMobile() ? 'px-4' : ''"
	>
		<div class="d-flex justify-space-around w-100">
			<div class="b-m w-100">
				<slot />
				<div class="d-flex justify-space-between mt-10">
					<BackBtn @click="$emit('back')">
						{{ t('back') }}
					</BackBtn>
					<VBtn
						color="am-blue"
						class="rounded-l elevation-0"
						dark
						:loading="isLoading"
						@click="$emit('next')"
					>
						{{ t('next') }}
					</VBtn>
				</div>
			</div>
			<Summary
				v-if="!$vuetify.breakpoint.smAndDown"
				:menu-items="menuItems"
				class="ml-6"
			/>
		</div>
	</PageContainer>
</template>

<script lang="ts">
	import Vue, { PropType } from 'vue';
	import Component, { mixins } from 'vue-class-component';
	import { MenuItem } from '@cnamts/vue-dot/src/patterns/ContextualMenu/types';
	import Summary from '@/components/SummaryView';

	const Props = Vue.extend({
		props: {
			menuItems: {
				type: Array as PropType<Array<MenuItem>>,
				required: true
			},
			isLoading: {
				type: Boolean,
				required: false
			}
		}
	});

	@Component<RegisterContainer>({
		components: { Summary }
	})
	export default class RegisterContainer extends mixins(Props) {
		t(path: string): string {
			return this.$t('views.register.' + path) as string;
		}
	}
</script>
